import { useNavigate, useLocation } from "react-router";

export interface History {
  push: (path: string, state?: any) => void;
  replace: (path: string, state?: any) => void;
  go: (n: number) => void;
  goBack: () => void;
  goForward: () => void;
  listen: (callback: (location: any) => void) => () => void;
  location: ReturnType<typeof useLocation>;
}

export function useHistory(): History {
  const navigate = useNavigate();
  const location = useLocation();

  return {
    push: (path: string, state?: any) => {
      navigate(path, { state });
    },
    replace: (path: string, state?: any) => {
      navigate(path, { replace: true, state });
    },
    go: (n: number) => {
      navigate(n);
    },
    goBack: () => {
      navigate(-1);
    },
    goForward: () => {
      navigate(1);
    },
    listen: (callback: (location: any) => void) => {
      // Since React Router v7 doesn't have a direct equivalent to history.listen,
      // we'll use a custom event listener on the window's popstate event
      const handlePopState = () => {
        callback(location);
      };
      window.addEventListener("popstate", handlePopState);
      return () => {
        window.removeEventListener("popstate", handlePopState);
      };
    },
    location,
  };
}
